import da from './da';
import en from './en';
import pt from './pt';

export default {
  da,
  en,
  pt,
};
